module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Glacier – PLEX NOIR","short_name":"Glacier","start_url":"/","background_color":"#0aff8d","theme_color":"#0aff8d","display":"minimal-ui","icon":"src/images/plexnoir_logo.png"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
